import Vue from 'vue';
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router';
import Home from '../views/home/Home.vue';
import { ControladorDeAutenticacion as Autenticacion } from '@env/shared/login/autenticar';
import { Socket } from './main';

Vue.use( VueRouter );

import '@com/inputs';
import '@com/selectores';
import '@com/shared';
import '@com/dialogs';


const ifNotAuthenticated: NavigationGuard = async ( to, from, next ) =>
{

    await Autenticacion.Iniciar();
    if ( !await Autenticacion.Validar() )
    {
        next();
    }
    else
    {
        next( '/' );
    }

};


const ifAuthenticated: NavigationGuard = async ( to, from, next ) =>
{


    await Autenticacion.Iniciar();
    if ( await Autenticacion.Validar() )
    {
        if ( !Socket.connected )
            await Socket.connect();
        next();
    }
    else
    {
        Autenticacion.Redireccionar = to.fullPath;
        next( '/login');
    }
};

const routes: RouterOptions = {
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/', component: () => import( '@env/shared/template/SinMenu.vue' ),
            children: [

                { path: '/', component: () => import( '@view/proveedores/proveedores.vue' ) },
                { path: '/proveedores', component: () => import( '@view/proveedores/proveedores.vue' ) },
            ]
        },
    ]
};


const router = new VueRouter( routes );

export default router;
